module.exports = __webpack_public_path__ + "img/panel.a978114.svg";